import { AspPayInvoiceRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function usePayAspInvoice() {
  const api = useApi();
  const [paying, setPaying] = useState(false);

  async function payAspInvoice(params: AspPayInvoiceRequest) {
    try {
      setPaying(true);
      const res = await api.payAspInvoice(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setPaying(false);
    }
  }

  return { paying, payAspInvoice };
}
